export const fmtAns = (ans) =>
  Number(ans).toLocaleString("en-US", {
    minimumFractionDigits: 6,
    maximumFractionDigits: 6,
  });

export const F = (num) => {
  return parseFloat(num) || 0;
};

export const avg = (n1, n2) => {
  return (n1 + n2) / 2;
};

export const squareKhit = (price, degrees) => {
  const I5 = Number(price);
  const K5 = Number(degrees);
  if (isNaN(I5) || isNaN(K5)) {
    return "0.00";
  }
  const Q5 = K5 / 180;

  const R5 = Math.sqrt(I5);

  const SQRT10 = 3.162278;

  const R3 = R5 / SQRT10;
  const R2 = R5 / 10;
  const R1 = R3 / 10;
  const R6 = R3 * 10;

  const X4 = (R1 + Q5) * (R1 + Q5) * 1000; // 900 degrees

  const X8 = (R2 + Q5) * (R2 + Q5) * 100; // 720 degrees

  const x6 = avg(X4, X8); // Mid num

  const X12 = (R3 + Q5) * (R3 + Q5) * 10; // 540 degrees

  const x10 = avg(X8, X12); // Mid num

  const X16 = (R5 + Q5) * (R5 + Q5); // 360 degrees

  const x14 = avg(X12, X16); // Mid num

  const X20 = ((R6 + Q5) * (R6 + Q5)) / 10; // 180 degrees

  const x18 = avg(X16, X20); // Mid num

  const X21 = ((R6 - Q5) * (R6 - Q5)) / 10; // -180 degrees

  const x2021 = avg(X20, X21); // Mid num

  const X25 = (R5 - Q5) * (R5 - Q5); // -360 degrees

  const x23 = avg(X21, X25); // Mid num

  const X29 = (R3 - Q5) * (R3 - Q5) * 10; // -540 degrees

  const x27 = avg(X25, X29); // Mid num

  const X33 = (R2 - Q5) * (R2 - Q5) * 100; // -720 degrees

  const x31 = avg(X29, X33); // Mid num

  const X37 = (R1 - Q5) * (R1 - Q5) * 1000; // -900 degrees

  const x35 = avg(X33, X37); // Mid num

  const Xs = [
    { degrees: 900, price: X4 },
    { degrees: 810, price: x6 },
    { degrees: 720, price: X8 },
    { degrees: 630, price: x10 },
    { degrees: 540, price: X12 },
    { degrees: 450, price: x14 },
    { degrees: 360, price: X16 },
    { degrees: 270, price: x18 },
    { degrees: 180, price: X20 },
    { degrees: 0, price: x2021 },
    { degrees: -180, price: X21 },
    { degrees: -270, price: x23 },
    { degrees: -360, price: X25 },
    { degrees: -450, price: x27 },
    { degrees: -540, price: X29 },
    { degrees: -630, price: x31 },
    { degrees: -720, price: X33 },
    { degrees: -810, price: x35 },
    { degrees: -900, price: X37 },
  ];

  const getAnswerPositive = (lp, up, sd) => {
    // Lower Price, Upper Price, Start Degree
    const diff = lp - up; // Difference
    const uv = diff / 180; // Unit Value
    const dd = K5 - sd; // Degree Difference
    const pd = dd * uv; // Price Difference
    const ans = Number(pd + up); // Answer
    return ans;
  };

  const getAnswerNegative = (X29, X25, sd) => {
    const Q26 = X25 - X29; // difference
    const R26 = Q26 / 180; // unit value
    const Q27 = K5 - Math.abs(sd);
    const Q28 = R26 * Q27;
    const ans = Number(X25 - Q28);
    return ans;
  };

  // Positive Range
  if (720 < K5 && K5 <= 900) {
    return [
      getAnswerPositive(X4, X8, 720),
      getAnswerPositive(X37, X33, 720),
      Xs,
    ];
  } else if (540 < K5 && K5 <= 720) {
    return [
      getAnswerPositive(X8, X12, 540),
      getAnswerPositive(X33, X29, 540),
      Xs,
    ];
  } else if (360 < K5 && K5 <= 540) {
    return [
      getAnswerPositive(X12, X16, 360),
      getAnswerPositive(X29, X25, 360),
      Xs,
    ];
  } else if (180 < K5 && K5 <= 360) {
    return [
      getAnswerPositive(X16, X20, 180),
      getAnswerPositive(X25, X21, 180),
      Xs,
    ];
  } else if (0 < K5 && K5 <= 180) {
    return [getAnswerPositive(X20, I5, 0), getAnswerPositive(X21, I5, 0), Xs];
    // Negative Range
  } else if (-180 < K5 && K5 <= 0) {
    return [getAnswerNegative(X21, I5, -0), null, Xs];
  } else if (-360 < K5 && K5 <= -180) {
    return [getAnswerNegative(X25, X21, -180), null, Xs];
  } else if (-540 < K5 && K5 <= -360) {
    return [getAnswerNegative(X29, X25, -360), null, Xs];
  } else if (-720 < K5 && K5 <= -540) {
    return [getAnswerNegative(X33, X29, -540), null, Xs];
  } else if (-900 <= K5 && K5 <= -720) {
    return [getAnswerNegative(X37, X33, -720), null, Xs];
  } else {
    return "Invalid Range";
  }
};

export const getDegreesFromResultAndPrice = (
  presult,
  price,
  start = -900,
  stop = 900,
  step = 1,
) => {
  if (isNaN(presult)) return;
  let min = Infinity;
  let degrees;
  let mres;
  // console.clear();
  for (
    let index = start;
    index <= stop;
    index = Number((index + step).toFixed(2))
  ) {
    // let [res, r2] = squareKhit(price, index);
    let [res] = squareKhit(price, index);
    // if (index < 0) {
    //   res = r2
    // }
    const diff = Math.abs(res - presult);
    // console.log({res, index, diff, presult})
    if (diff < min) {
      min = diff;
      degrees = index;
      mres = res;
    }
  }
  if (step === 1) {
    // console.clear();
    const start = mres > presult ? degrees - 1 : degrees;
    const stop = mres < presult ? degrees + 1 : degrees;
    // console.log({start, stop, mres});
    return getDegreesFromResultAndPrice(mres, price, start, stop, 0.01);
  }
  // console.log({mres, degrees});
  return degrees;
};

export const absoluteDifference = (num1, num2) => Math.abs(num1 - num2);
